import React, { useState } from "react";
import gsap from "gsap";
import { css } from "@emotion/core";
import { useSpring, animated } from "react-spring";
import styled from "@emotion/styled";
import { colors, mediaQueries } from "../../configs/_configSite";

// Components

// Images
// import VideoFile1 from "";
import VideoFile2 from "../../videos/comission-2.mp4";
import ImgPhoneCarrierLogo from "../../images/phone-carrier/phone-carrier-rescue-logo.jpg";
import VideoPLayerFullScreen from "../VideoPlayers/VideoPlayerFullScreen";

// TOGLE BOX COMPONENT ---------------------------------------------

const ContainerBox = styled.section`
  position: absolute;
  z-index: 1;
  top: 15vh;
  left: 10vw;
  width: 500px;
  box-sizing: border-box;

  background: transparent;

  @media (max-width: ${mediaQueries.lg}px) {
    transform: scale(0.95);
    left: 5vw;
    top: 15vh;
  }

  @media (max-width: ${mediaQueries.lg}px) {
    transform: scale(0.9);
    width: 700px;
    left: 5vw;
    top: 10vh;
  }

  @media (max-width: ${mediaQueries.sm}px) {
    transform: scale(0.8);
    width: 500px;
    left: 0vw;
    top: 5vh;
  }

  @media (max-width: ${mediaQueries.xs}px) {
    transform: scale(0.9);
    width: 100%;
    left: 0;
    right: 0;
    margin: 0 auto;
    top: 8vh;
  }
`;

const BoxWrapper = styled.div`
  position: relative;
  width: 100%;
  padding: 5px;
  margin-bottom: 50px;
  box-sizing: border-box;
  transition: 1s ease-in;

  background: transparent;

  &:before {
    position: absolute;
    z-index: 2;
    display: block;
    content: "";
    top: -10px;
    left: -10px;

    border-top: 25px solid red;
    border-left: 25px solid red;
    border-bottom: 25px solid transparent;
    border-right: 25px solid transparent;
  }
`;

const Box = styled.section`
  position: relative;
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  transition: 1s ease-in;
  overflow: hidden;

  background: black;
`;

const BoxTitle = styled.section`
  font-family: Assistant;
  font-weight: bold;
  font-size: 1.5rem;
  margin-bottom: 15px;
`;

const BoxText = styled.section`
  font-family: Assistant;
  font-size: 1rem;
`;

const BoxLink = styled.a`
  position: absolute;
  top: 140px;
  right: 15px;
  font-family: Assistant;
  font-size: 0.8rem;
  color: ${colors.gold};
  text-decoration: none;
  float: right;
  transition: 0.2s;

  &:hover {
    opacity: 0.75;
  }
`;

// const ToggleBox = () => {
//   return(
//     <ContainerBox>
//       <b
//     </ContainerBox>
//   );
// }

// DATE COMPONENT ---------------------------------------------

const ContainerDate = styled.section`
  position: absolute;
  z-index: 1;
  bottom: 5vh;
  right: 10vw;
  width: 400px;
  box-sizing: border-box;

  background: transparent;

  @media (max-width: ${mediaQueries.lg}px) {
    transform: scale(0.95);
    right: 5vw;
    bottom: 5vh;
  }

  @media (max-width: ${mediaQueries.md}px) {
    transform: scale(0.85);
    right: 5vw;
    bottom: 0vh;
  }

  @media (max-width: ${mediaQueries.xs}px) {
    transform: scale(0.9);
    display: none;
    width: 100%;
    margin: 0 auto;
    left: 0;
    right: 0;
    bottom: 0vh;
  }
`;

const DateWrapper = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  min-height: 150px;
  margin-bottom: 15px;
  box-sizing: border-box;

  background: white;

  @media (max-width: ${mediaQueries.xs}px) {
    &:nth-of-type(2) {
      display: none;
    }
  }
`;

const DateTitle = styled.p`
  font-family: Assistant;
  font-weight: bold;
  font-size: 1rem;
  margin-top: 0;
  margin-bottom: 15px;
`;

const DateLink = styled.a`
  position: absolute;
  bottom: 5px;
  right: 15px;
  font-family: Assistant;
  font-size: 0.8rem;
  color: ${colors.gold};
  text-decoration: none;
  float: right;
  transition: 0.2s;

  &:hover {
    opacity: 0.75;
  }
`;

const DateLogo = styled.div`
  position: relative;
  float: right;
  height: 150px;
  width: 250px;

  background: url(${ImgPhoneCarrierLogo}) no-repeat center / contain;

  @media (max-width: ${mediaQueries.xs}px) {
    display: none;
  }
`;

const dates = [
  {
    month: "APR",
    day: "20",
    year: "2021",
    title: "Sons and Daughters of Thunder",
    text:
      "Capilla Fidelidad Church supports Wayuu missions message....more to follow.....",
    link:
      "https://www.facebook.com/CapillaFidelidad/videos/473742074063084/?t=124"
  },
  {
    month: "OCT",
    day: "01",
    year: "2021",
    title: "World Events Weather Report",
    text:
      "Pastor Pete, Reliance Church 2021 Mission Trip!....more to follow.....",
    link: "https://www.reliancechurch.org/espanol/"
  }
];

// SECTION COMPONENT ---------------------------------------------

// Style
const Background = styled(animated.div)`
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  opacity: 0;
`;

const Container = styled.section`
  position: relative;
  height: 100%;
  width: 100%;
`;

// Data
const data = [
  {
    title: "The Great Commission",
    thumbTitle: "Welcome",
    imageBackground: <VideoPLayerFullScreen video={VideoFile2} />,
    text: `Wayuu people healthcare...... more to follow.....`,
    cornerColor: "green",
    link: "https://www.reliancechurch.org/connect/give/"
  }
];

const calc = (x, y) => [x - window.innerWidth / 2, y - window.innerHeight / 2];
const trans1 = (x, y) => `translate3d(${x / 50}px,${y / 50}px,0) scale(1.1)`;

const getNextDate = () => {
  const date = new Date();
  // if today is tuesday or thursday
  if (date.getDay() === 2 || date.getDay() === 4) {
    // do nothing
  }
  // if today is wednesday, add a day and show thursday
  if (date.getDay() === 3) {
    date.setDate(date.getDate() + 1);
  }
  // if today is fri, add 4 and show tuesday
  if (date.getDay() === 5) {
    date.setDate(date.getDate() + 4);
  }
  // if today is sat, add 3 and show tuesday
  if (date.getDay() === 6) {
    date.setDate(date.getDate() + 3);
  }
  // if today is sun, add 2 and show tuesday
  if (date.getDay() === 0) {
    date.setDate(date.getDate() + 2);
  }
  // if today is mon, add 1 and show tuesday
  if (date.getDay() === 1) {
    date.setDate(date.getDate() + 1);
  }
  return {
    month: date.toLocaleDateString(undefined, { month: "short" }).toUpperCase(),
    day: date.getDate(),
    year: date.getFullYear()
  };
};

export default () => {
  const [pops, set] = useSpring(() => ({
    xy: [0, 0],
    config: { mass: 2, tension: 250, friction: 140 }
  }));
  const [activeIndex, setActiveIndex] = useState(0);
  const [loading, setLoading] = useState(false);

  const clickSetIndex = index => {
    if (!loading) {
      gsap.to(`#content-toggle-background-${activeIndex}`, 1, {
        css: { opacity: 0 }
      });
      gsap.to(`#content-toggle-background-${index}`, 1, {
        delay: 0.5,
        css: { opacity: 1 }
      });
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 500);
      setActiveIndex(index);
    }
  };

  dates[0] = {
    ...dates[0],
    ...getNextDate()
  };

  return (
    <Container
      onMouseMove={({ clientX: x, clientY: y }) => set({ xy: calc(x, y) })}
    >
      <ContainerBox>
        {data.map((item, i) => (
          <BoxWrapper
            css={css`
              &:before {
                position: absolute;
                z-index: 2;
                display: block;
                content: "";
                top: -10px;
                left: -10px;

                border-top: 25px solid ${item.cornerColor};
                border-left: 25px solid ${item.cornerColor};
                border-bottom: 25px solid transparent;
                border-right: 25px solid transparent;
              }
            `}
          >
            <Box
              type="button"
              onClick={() => (activeIndex !== i ? clickSetIndex(i) : null)}
              css={css`
                cursor: ${activeIndex === i ? `initial` : `pointer`};
                height: ${activeIndex === i ? `175px` : `60px`};
                background: ${activeIndex === i ? `white` : `rgba(0,0,0,0.5)`};
                color: ${activeIndex === i ? `black` : `white`};
              `}
            >
              <BoxTitle>{item.title}</BoxTitle>
              <BoxText>{item.text}</BoxText>
              {item.link.length > 0 && (
                <BoxLink href={item.link}>
                  go to website
                  <svg
                    css={css`
                      position: relative;
                      margin-left: 10px;
                      top: 5px;
                    `}
                    width="11"
                    height="18"
                    viewBox="0 0 11 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.58578 7.58578C10.3668 8.36683 10.3668 9.63316 9.58579 10.4142L3.41422 16.5858C2.15429 17.8457 1.80289e-06 16.9534 1.543e-06 15.1716L-2.57375e-07 2.82843C-5.1727e-07 1.04662 2.15428 0.154283 3.41421 1.41421L9.58578 7.58578Z"
                      fill="#D7B401"
                    />
                  </svg>
                </BoxLink>
              )}
            </Box>
          </BoxWrapper>
        ))}
      </ContainerBox>

      <ContainerDate>
        {dates.map(item => (
          <DateWrapper>
            <div
              css={css`
                display: flex;
                flex-direction: column;
                font-family: Blinker;
                min-height: 100px;
                width: 120px;
                padding-top: 15px;
                text-align: center;
                background: black;
                color: white;
              `}
            >
              <span>{item.month}</span>
              <span
                css={css`
                  font-size: 2rem;
                `}
              >
                {item.day}
              </span>
              <span>{item.year}</span>
            </div>
            <div
              css={css`
                padding: 15px;
              `}
            >
              <DateTitle>{item.title}</DateTitle>
              <BoxText>{item.text}</BoxText>
              {item.link.length > 0 && (
                <DateLink href={item.link}>
                  go to website
                  <svg
                    css={css`
                      position: relative;
                      margin-left: 10px;
                      top: 5px;
                    `}
                    width="11"
                    height="18"
                    viewBox="0 0 11 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.58578 7.58578C10.3668 8.36683 10.3668 9.63316 9.58579 10.4142L3.41422 16.5858C2.15429 17.8457 1.80289e-06 16.9534 1.543e-06 15.1716L-2.57375e-07 2.82843C-5.1727e-07 1.04662 2.15428 0.154283 3.41421 1.41421L9.58578 7.58578Z"
                      fill="#D7B401"
                    />
                  </svg>
                </DateLink>
              )}
            </div>
          </DateWrapper>
        ))}
        <DateLogo />
      </ContainerDate>

      {data.map((item, i) => (
        <Background
          key={item.title}
          style={{ transform: pops.xy.interpolate(trans1) }}
          id={`content-toggle-background-${i}`}
          className="content-toggle-background"
          css={css`
            opacity: ${i === 0 ? 1 : 0};
          `}
        >
          {item.imageBackground}
        </Background>
      ))}
    </Container>
  );
};
